import React, { useState } from "react";
import './addresses.css';
import HomeAddress from "./HomeAddress";
import WorkAddress from "./WorkAddress";
import { useDispatch, useSelector } from "react-redux";
import { updateAddress } from "../../appState/slices/auth/authSlice";

const Addresses = () => {
    // const [adresstypes, setAdresstypes] = useState(["home", "work"]);
    const user = useSelector(state => state.auth.user);
    return (
        <div>
            <div className="single-order-fixed">
                <div className="myordercontainer">
                    <div className="profile-mainaddress-container t6">
                        <div className="t3 font-semibold">Addresses</div>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-lg-6 col-md-6 col-sm-12 pb-4 pe-1 ps-0">
                                    <HomeAddress address={user.addresses.home} addresstype = "home" />
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-12 pb-4 pe-0 ps-1">
                                    <HomeAddress address={user.addresses.work} addresstype = "work" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Addresses;
